export const RouteName = {
  HOME: 'home',
  CASES: 'cases',
  CASE_DETAIL: 'case-detail',
  GIVEAWAYS: 'giveaways',
  GIVEAWAY_DETAIL: 'giveaway-detail',
  DAILY_FREE: 'daily-free',
  DAILY_FREE_DETAIL: 'daily-free-detail',
  EVENTS: 'events',
  TIDES_OF_WAR: 'tides-of-war',
  ARCADE: 'arcade',
  ARCADE_WORDLE: 'arcade-wordle',
  ARCADE_PRICE_GUESS: 'arcade-price-guess',
  ARCADE_MINESWEEPER: 'arcade-minesweeper',
  ARCADE_TRIVIA: 'arcade-trivia',
  ARCADE_MEMORY: 'arcade-memory',
  ARENA: 'arena',
  ARENA_CREATE: 'arena-create',
  ARENA_ROOM: 'arena-room',
  CONTRACTS: 'contracts',
  SKIN_CLASH: 'skin-clash',
  UPGRADE: 'upgrade',
  LOGIN: 'login',
  PRIVACY_POLICY: 'privacy-policy',
  WITHDRAWAL_POLICY: 'withdrawal-policy',
  AML_KYC: 'aml-kyc',
  TERMS_OF_SERVICE: 'terms-of-service',
  NOT_FOUND: '404',
  PROFILE: 'profile',
  PUBLIC_PROFILE: 'public-profile',
  PROVABLY_FAIR: 'provably-fair',
  ODDS_HISTORY: 'odds-history',
  PAYOP_RESULT: 'payop-result',
  PAYOP_FAILED: 'payop-failed',
  SUPPORT: 'support',
  UNSUBSCRIBE: 'unsubscribe',
  ALPHA_WHALES: 'alpha-whales-club',
  WHALE_PROTOCOL: 'whale-protocol',
} as const

export type RouteName = (typeof RouteName)[keyof typeof RouteName]
